
import { Vue, Component, Watch } from 'vue-property-decorator';
import { isWeiXin } from '@/common/ts/common';
import BottomTabbar from '@/components/next/BottomTabbar.vue';
// import { getBaseInfo } from './api';

const baseUrl = '0420BMB';

@Component({
  components: {
    BottomTabbar,
  },
})
export default class ViewHolder extends Vue {
  act: number = 1;
  tabs: any[] = [
    {
      title: '差错列表',
      path: `/${baseUrl}/home`,
      id: 1,
    },
    {
      title: '审读数、差错数',
      path: `/${baseUrl}/much`,
      id: 2,
    },
    {
      title: '审读提醒',
      path: `/${baseUrl}/hostpot`,
      id: 3,
    },
  ];
  activeTab = 1;
  baseInfo: any = {};
  show: boolean = false;

  @Watch('$route', { immediate: true })
  onRouteChange() {
    // 设置分享文案
    this.show = !this.$route.path.includes('login');
    this.act = this.$route.path.includes('home')
      ? 1
      : this.$route.path.includes('much')
      ? 2
      : this.$route.path.includes('hostpot')
      ? 3
      : 4;
    const cover =
      'https://image2.cqcb.com/1075dd015b5d3b3545e6379f33081b4e.jpeg';
    // App分享
    this.$appShareInfo({
      title: '分享主标题',
      url: location.href,
      subtitle: `分享副标题`,
      classId: -1,
      id: -1,
      image: cover,
      type: 3,
    });
    // 微信分享
    if (isWeiXin()) {
      this.$wxShareInfo({
        title: '分享主标题',
        subtitle: `分享副标题`,
        image: cover,
      });
    }
  }
  changPath(item: any) {
    if (item.path === this.$route.path) {
      return false;
    }

    this.act = item.id;
    this.$router.replace(item.path);
  }

  // async created() {
  //   const index = this.tabs.findIndex((item: any) => {
  //     return item.path === this.$route.path;
  //   });
  //   this.activeTab = index > -1 ? index : 0;
  //   const ret = await getBaseInfo();
  //   this.baseInfo = ret.data;
  //   // 添加pv统计
  //   if (this.baseInfo.activityId) {
  //     this.$addPv(this.baseInfo.activityId);
  //   }
  // }
}
